import React, {useEffect, useState, useRef} from "react";
import Mainheader from "../../components/MainHeader/Mainheader";
import {Link, useNavigate} from "react-router";
import "./appointment.css";
import Useimg from "../../assets/images/userImg.png";
import DoctorImg from "../../assets/images/appointment-doctor-img1.svg";
import DoctorImg2 from "../../assets/images/appointment-doctor-img2.svg";
import DoctorImg3 from "../../assets/images/appointment-doctor-img3.svg";
import DoctorImg4 from "../../assets/images/appointment-doctor-img4.svg";
import DoctorImg5 from "../../assets/images/appointment-doctor-img5.svg";
import DoctorImg6 from "../../assets/images/appointment-doctor-img6.svg";
import StarIcon from "../../assets/images/appointment-star-icon.svg";
import StarIcon2 from "../../assets/images/4.5star.svg";
import AddIcon from "../../assets/images/appointment-add-icon.svg";
import RelatedDocumentIcon from "../../assets/images/appointment-document-icon.svg";
import WriteReviewDisabledIcon from "../../assets/images/appointment-quality-disabled-icon.svg";
import ChatImg from "../../assets/images/appointment-chat-icon.svg";
import ReviewImg from "../../assets/images/appointment-review-img.svg";
import RatingImg from "../../assets/images/appointment-star-rating-big-img.svg";
import VideoIcon from "../../assets/images/appointment-video-icon.svg";
import ChatAttachIcon from "../../assets/images/appointment-attach-icon.svg";
import ChatUserImg1 from "../../assets/images/appointment-chat-user-img1.svg";
import CrossIcon from "../../assets/images/CrossIcon.svg";
import downloadIcon from "../../assets/images/download.svg";
import whiteDownloadIcon from "../../assets/images/white-download.svg";
import whiteImageIcon from "../../assets/images/white-image-icon.svg";
import blackImageIcon from "../../assets/images/black-image-icon.svg";
import whitePdfIcon from "../../assets/images/white-pdf-icon.svg";
import blackPdfIcon from "../../assets/images/black-pdf-icon.svg";
import whiteDocxIcon from "../../assets/images/white-docx-icon.svg";
import blackDocxIcon from "../../assets/images/black-docx-icon.svg";
import Afterloginheader from "../../components/MainHeader/Afterloginheader";
import {
  addReviewApi,
  cancelAppointmentApi,
  createNoteApi,
  dateAvailabilityApi,
  fetchHolidayApi,
  fetchPatientMessageDetailsApi,
  getAppointmentDetailsApi,
  getAppointmentMessageApi,
  getCancelReasonApi,
  getPatientAppointmentApi,
  getRescheduleReasonApi,
  patientCancelAppointmentApi,
  patientFetchNoteApi,
  patientRescheduleAppointmentApi,
  readAppointmentMessageApi,
  rescheduleAppointmentApi,
  sendAppointmentMessageApi,
} from "../../services/apiService";
import {format} from "date-fns";
import {toast} from "react-toastify";
import {IMAGE_URL} from "../../app_url";
import {useUserContext} from "../../context/UserContext";
import NoAppointmentCalendarIcon from "../../assets/images/no-appointment-calendar-icon.svg";
import Skeleton from "react-loading-skeleton";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  TelegramIcon,
} from "react-share";
import ReactStars from "react-rating-stars-component";
import {DEFAULT_PROFILE_IMAGE} from "../../app_url";
import {chatMessgaeDateFormat, getFileExtension} from "../../utils/commonData";
import cancelIcon from "../../assets/images/cancel-btn.svg";
import Calendar from "react-calendar";
import moment from "moment";
import {X} from "lucide-react";

const MyAppointment = () => {
  const {userData, setUserData} = useUserContext();
  const navigate = useNavigate();
  const chatListRef = useRef(null);
  const chatFileRef = useRef(null);
  // Tab visibility
  const [allDetails, setAllDetails] = useState();
  const [appointmentDetails, setAppointmentDetails] = useState();

  const [screenLoadingDoctor, setScreenLoadingDoctor] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [notesList, setNotesList] = useState();
  const [selectedAppId, setSelectedAppId] = useState();
  const [activeTab, setActiveTab] = useState("upcoming");
  const [noteBtnDis, setNoteBtnDis] = useState(false);
  const [noteText, setNoteText] = useState();
  const [sharePopupShow, setSharePopupShow] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [messageSenderObj, setMessageSenderObj] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [messageText, setMessageText] = useState();
  const [messageFile, setMessageFile] = useState();
  const [messageSending, setMessageSending] = useState(false);
  const [writeReviewObj, setWriteReviewObj] = useState({star: 0, review: ""});
  const [modalBtnDis, setModalBtnDis] = useState(false);
  const [rescheduleReason, setRescheduleReason] = useState();
  const [reschedulePopupShow, setReschedulePopupShow] = useState(false);
  const [calendarValue, setCalendarValue] = useState(new Date());
  const [availDates, setAvailDates] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [futureDate, setFutureDate] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [skelLoading, setSkelLoading] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [rescheduleReasonList, setRescheduleReasonList] = useState();
  const [showCancelAppointmnet, setShowCancelAppointmnet] = useState(false);
  const [cancelReason, setCancelReason] = useState();
  const [cancelReasonList, setCancelReasonList] = useState();

  const toggleCancelAppointmnet = () => {
    setShowCancelAppointmnet(!showCancelAppointmnet);
  };

  const handleTabClick = tab => {
    getPatientAppointment(tab);
    setActiveTab(tab);
  };

  // Modal visibility
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const [showModal1, setShowModal1] = useState(false);

  const toggleModal1 = () => {
    setShowModal1(!showModal1);
  };

  const [showModal2, setShowModal2] = useState(false);

  const toggleModal2 = () => {
    setShowModal2(!showModal2);
  };

  const [showModal22, setShowModal22] = useState(false);

  const toggleModal22 = () => {
    setShowModal22(!showModal22);
  };

  const [showModal23, setShowModal23] = useState(false);

  const toggleModal23 = () => {
    setShowModal23(!showModal23);
  };

  // State to manage visibility
  const [isVisible, setIsVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isActive2, setIsActive2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isActive3, setIsActive3] = useState(false);

  // Function to toggle the visibility
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
    setIsActive(!isActive);
  };

  const toggleVisibility2 = () => {
    setIsVisible2(!isVisible2);
    setIsActive2(!isActive2);
  };

  const toggleVisibility3 = () => {
    setIsVisible3(!isVisible3);
    setIsActive3(!isActive3);
  };

  const formatDate = dateString => {
    const date = new Date(dateString);
    return format(date, "MMMM dd, yyyy");
  };

  const getPatientAppointment = async type => {
    setScreenLoadingDoctor(true);
    try {
      let response = await getPatientAppointmentApi(type);
      if (response) {
        if (response.data.res === true) {
          setAllDetails(response.data.data);
          if (response.data.data.length > 0) {
            getAppointmentDetails(response.data.data[0]["id"]);
            getAppointmentMessage(response.data.data[0]["doctor_id"]);
            getDateAvailabilityList(response.data.data[0]["doctor_id"], format(calendarValue, "yyyy-MM-dd"), "For online consultation");
            setSelectedAppId(response.data.data[0]["id"]);
          } else {
            getAppointmentDetails("h1");
            getAppointmentMessage("");
          }
        } else {
          getAppointmentDetails("");
          getAppointmentMessage("");
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
      setScreenLoadingDoctor(false);
    } catch (error) {
      setScreenLoadingDoctor(false);
      //toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const handleSelectAppointment = async (id, doctorId) => {
    getAppointmentDetails(id);
    getAppointmentMessage(doctorId);
    setSelectedAppId(id);
  };

  const getAppointmentDetails = async id => {
    setScreenLoading(true);
    try {
      let response = await getAppointmentDetailsApi(id);
      if (response) {
        if (response.data.res === true) {
          setAppointmentDetails(response.data.data[0]);
          getPatientNote(response.data.data[0].id);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
      setScreenLoading(false);
    } catch (error) {
      setScreenLoading(false);
      //toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const getPatientNote = async id => {
    try {
      let fd = new FormData();
      fd.append("appointment_id", id);
      let response = await patientFetchNoteApi(fd);
      if (response) {
        if (response.data.res === true) {
          setNotesList(response.data.data);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      //toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const addPatientNote = async () => {
    if (selectedAppId) {
      if (!noteText) {
        toast.warning("Please enter note.", {autoClose: 1500});
      } else {
        try {
          setNoteBtnDis(true);
          let fd = new FormData();
          fd.append("appointment_id", selectedAppId);
          fd.append("notes", noteText);
          let response = await createNoteApi(fd);
          if (response) {
            if (response.data.res === true) {
              getPatientNote(selectedAppId);
              setShowModal2(false);
              setNoteText(null);
              toast.success(response.data.msg, {autoClose: 1500});
            } else {
              toast.error(response.data.msg, {autoClose: 1500});
            }
          }
          setNoteBtnDis(false);
        } catch (error) {
          setNoteBtnDis(false);
          console.error(error);
          toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
        }
      }
    } else {
      toast.error("Appointment not found.", {autoClose: 1500});
    }
  };

  const getAppointmentMessage = async doctorId => {
    try {
      const fd = new FormData();
      fd.append("from_id", doctorId);
      fd.append("type", "patient");

      let response = await fetchPatientMessageDetailsApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.data.length > 0) {
            setMessageList(response.data.data);
          } else {
            setMessageList([]);
          }
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);

      // Check if the response is okay (status code 200)
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob(); // Convert response to a Blob
      const url = window.URL.createObjectURL(blob); // Create a temporary URL for the Blob

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // Set the filename for download
      document.body.appendChild(link);
      link.click(); // Programmatically click the link to trigger the download
      document.body.removeChild(link); // Clean up

      // Release the Blob URL after download
      window.URL.revokeObjectURL(url);

      toast.success("Downloaded successfully", {autoClose: 1500});
    } catch (error) {
      console.error("Error downloading the file:", error);
      toast.error("Failed to download the file.", {autoClose: 1500});
    }
  };

  const handleChatFileChange = event => {
    const acceptedFileTypes = [
      "image/jpeg", // JPG
      "image/png", // PNG
      "application/pdf", // PDF
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    ];
    const file = event.target.files[0];
    if (!file) {
      toast.warning("No file selected.", {autoClose: 1500});
      return;
    }

    // Validate the file type
    if (!acceptedFileTypes.includes(file.type)) {
      toast.warning("Invalid file type. Please select a JPG, PNG, PDF, or DOCX file.", {autoClose: 1500});
      return;
    }

    setMessageFile(file);
  };

  const handleSendMesssage = async () => {
    if (!messageText && !messageFile) {
      toast.warning("Please enter a message or select a file to send.", {autoClose: 1500});
      return;
    } else {
      try {
        setMessageSending(true);
        const fd = new FormData();
        fd.append("appointment_id", selectedAppId);
        fd.append("to_id", appointmentDetails?.doctor_details?.id);
        fd.append("message", messageText ? messageText : "");
        fd.append("types", "patient");
        fd.append("message_file", messageFile ? messageFile : "");
        fd.append("linked_to", userData?.users?.id ? userData?.users?.id : "");

        let response = await sendAppointmentMessageApi(fd);
        if (response) {
          if (response.data.res === true) {
            setMessageFile(null);
            setMessageText("");
            let tempArray = [...messageList];
            response.data.data.from = response.data.data.from_first_name + " " + response.data.data.from_last_name;
            tempArray.push(response.data.data);
            setMessageList(tempArray);
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setMessageSending(false);
      }
    }
  };

  const readAppointmentMessage = async () => {
    try {
      const fd = new FormData();
      fd.append("from_id", allDetails?.find(item => parseInt(item?.id) === parseInt(selectedAppId))?.doctor_id);
      fd.append("read_type", "patient");

      let response = await readAppointmentMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempSelectedApp = allDetails?.find(item => parseInt(item?.id) === parseInt(selectedAppId));
          let tempAllDetails = [...allDetails];
          tempAllDetails?.forEach(element => {
            if (parseInt(element?.doctor_id) === parseInt(tempSelectedApp?.doctor_id)) {
              element.patient_read_count = 0;
            }
          });
          // let tempAllDetails = allDetails.map(item => (item.id === selectedAppId ? {...item, patient_read_count: 0} : item));
          setAllDetails(tempAllDetails);

          let tempAppointmentDetails = appointmentDetails ? {...appointmentDetails} : {};

          tempAppointmentDetails.patient_read_count = 0;
          setAppointmentDetails(tempAppointmentDetails);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    } finally {
    }
  };

  const handleSubmitReview = async () => {
    if (writeReviewObj.star === 0) {
      toast.warning("Please select a rating.", {autoClose: 1500});
      return;
    } else {
      setModalBtnDis(true);
      try {
        const fd = new FormData();
        fd.append("appointment_id", appointmentDetails?.id);
        fd.append("doctor_id", appointmentDetails?.doctor_id);
        fd.append("rating", writeReviewObj?.star);
        fd.append("comment", writeReviewObj?.review || "");

        let response = await addReviewApi(fd);
        if (response) {
          if (response.data.res === true) {
            setShowModal1(false);
            getAppointmentDetails(selectedAppId);
            // let tempAppointmentDetails = appointmentDetails ? {...appointmentDetails} : {};
            // tempAppointmentDetails?.reviewlist.push(response.data.data);
            // setAppointmentDetails(tempAppointmentDetails);
            toast.success(response.data.msg || "Review submitted successfully.", {autoClose: 1500});
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setModalBtnDis(false);
      }
    }
  };

  const getDateAvailabilityList = async (docId, date, consultationType) => {
    if (docId && date && consultationType) {
      try {
        setSkelLoading(true);
        let formData = new FormData();
        formData.append("doctor_id", docId);
        formData.append("date", date);
        formData.append("consultation_types", consultationType);

        let response = await dateAvailabilityApi(formData);
        if (response) {
          if (response.data.res === true) {
            // const notAvailableSet = new Set(response.data.notAvailable.map(({time}) => time));
            // const tempArray = response.data.data.filter(item => !notAvailableSet.has(item));
            const tempFormatHoliday = response.data.holiday ? response.data.holiday.map(item => item.holiday_date) : [];
            if (tempFormatHoliday.includes(date)) {
              setAvailDates([]);
            } else {
              setAvailDates(response.data.data);
            }
            setBookedAppoinment(response.data.notAvailable.map(({time}) => time));
            const tempFutureDate = moment().add(parseInt(response.data.future_days, 10), "days");
            setFutureDate(tempFutureDate);
            setSelectedTime(null);
            setRescheduleReason(null);
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setSkelLoading(false);
      }
    }
  };

  const handleDateClick = async date => {
    const newDate = date.toDateString();
    setCalendarValue(date);
    getDateAvailabilityList(allDetails[0]?.doctor_id, format(date, "yyyy-MM-dd"), "For online consultation");
  };

  const tileClassName = ({date}) => {
    const formattedDate = date.toDateString();
    return calendarValue === formattedDate ? "highlighted-date" : null;
  };

  const getHolidays = async date => {
    if (date) {
      try {
        let formData = new FormData();
        formData.append("day", date);

        let response = await fetchHolidayApi(formData);
        if (response) {
          if (response.data.res === true) {
            const formattedDates = response.data.data.map(item => new Date(item.holiday_date).toDateString());
            setSelectedDates(formattedDates);
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      }
    }
  };

  const handleActiveStartDateChange = ({action, activeStartDate, view}) => {
    if (action === "prev" || action === "next") {
      const formattedDate = format(activeStartDate, "yyyy-MM");
      getHolidays(formattedDate);
    }
  };

  const handleSelectTime = time => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach(element => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning("Oops! This time slot is full. Please try on different time.", {autoClose: 1500});
        setSelectedTime(null);
      } else {
        setSelectedTime(title);
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning("Oops! This time slot is already taken. Please choose a different slot.", {autoClose: 1500});
        setSelectedTime(null);
      } else {
        setSelectedTime(time);
      }
    }
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  const getRescheduleReason = async () => {
    try {
      let response = await getRescheduleReasonApi();
      if (response) {
        if (response.data.res === true) {
          setRescheduleReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const handleReschedule = async () => {
    if (!selectedTime) {
      toast.warning("Please select a time.", {autoClose: 1500});
    } else if (!rescheduleReason) {
      toast.warning("Please select reschedule reason.", {autoClose: 1500});
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", selectedAppId);
        fd.append("reason", rescheduleReason);
        fd.append("appointment_date", format(calendarValue, "yyyy-MM-dd"));
        fd.append("time", selectedTime);

        let response = await patientRescheduleAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg ? response.data.msg : "Appointment rescheduled successfully.", {autoClose: 1500});
            getPatientAppointment("all");
            // getDateAvailabilityList(allDetails[0]?.doctor_id, format(calendarValue, "yyyy-MM-dd"), "For online consultation");
            setReschedulePopupShow(false);
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setModalBtnDis(false);
      }
    }
  };

  const getCancelReason = async () => {
    try {
      let response = await getCancelReasonApi();
      if (response) {
        if (response.data.res === true) {
          setCancelReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const handleCancelAppointment = async () => {
    if (!cancelReason) {
      toast.warning("Please select cancel reason.", {autoClose: 1500});
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", selectedAppId);
        fd.append("reason", cancelReason);

        let response = await patientCancelAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg ? response.data.msg : "Appointment cancelled successfully.", {autoClose: 1500});
            setShowCancelAppointmnet(false);
            getPatientAppointment("all");
          } else {
            toast.error(response.data.msg, {autoClose: 1500});
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
      } finally {
        setModalBtnDis(false);
      }
    }
  };

  const showDelayedTimeFunction = (mainTime, delayTime) => {
    let time = moment(mainTime, "HH:mm");
    let delay = delayTime;

    let [hours, minutes] = delay.split(":").map(Number);

    time.add(hours, "hours");
    time.add(minutes, "minutes");

    return time.format("HH:mm");
  };

  useEffect(() => {
    getPatientAppointment("upcoming");
    getRescheduleReason();
    getCancelReason();
  }, []);

  useEffect(() => {
    // Scroll to the bottom of the chat list
    if (chatListRef.current) {
      chatListRef.current.scrollTop = chatListRef.current.scrollHeight;
    }
  }, [selectedAppId, messageList, isVisible]);

  return (
    <div className="Main">
      <Afterloginheader />
      <div className="AppointmentBody">
        <div className="CustomContainer">
          <div className="AppointmentTopBox">
            <h3>My appointment</h3>
            <ul className="RightTab">
              <li
                className={activeTab === "all" ? "active" : ""}
                onClick={() => handleTabClick("all")}
                //onClick={() => getPatientAppointment('all')}
              >
                View All
              </li>
              <li
                className={activeTab === "upcoming" ? "active" : ""}
                onClick={() => handleTabClick("upcoming")}
                //onClick={() => getPatientAppointment('upcoming')}
              >
                Upcoming Appointment
              </li>
              <li
                className={activeTab === "past" ? "active" : ""}
                onClick={() => handleTabClick("past")}
                //onClick={() => getPatientAppointment('past')}
              >
                Past Appointment
              </li>
            </ul>
          </div>
          <div className="TabContent">
            <div id="all" className="TabContentBlock">
              <div className="MyAppointmentBox">
                <div className="LeftMyAppointtBox">
                  <ul className="AppointmentList">
                    {screenLoadingDoctor ? (
                      <div className="Card">
                        <Skeleton count={1} height={40} width={"100%"} baseColor="#cfd5f9" />
                        <br />
                        <p>
                          <Skeleton count={1} height={40} width={"100%"} baseColor="#cfd5f9" />
                        </p>
                      </div>
                    ) : (
                      <>
                        {allDetails?.map((item, index) => (
                          <li
                            className={selectedAppId === item?.id ? "Selected" : ""}
                            key={index}
                            onClick={() => handleSelectAppointment(item?.id, item?.doctor_id)}>
                            <div className={`Card ${item?.delay_id ? "delayCard" : ""} `}>
                              <div className="TopCardBox">
                                <div className="ImgBox">
                                  <img
                                    src={item?.doctor_details[0]?.profile_pic_url ?  item?.doctor_details[0]?.profile_pic_url : DEFAULT_PROFILE_IMAGE}
                                    alt="Doctor image"
                                  />
                                </div>
                                <div className="ImgTextBox">
                                  <h4>
                                    {/* Dr Debrorah Dang */}
                                    {item?.doctor_details[0]?.first_name} {item?.doctor_details[0]?.last_name}
                                  </h4>
                                  <h5>{item?.doctor_details[0]?.doctor_specialitie}</h5>
                                  {item?.reviewlist[0]?.averageRating ? (
                                    <h6>
                                      <img src={StarIcon} alt="Doctor image" /> {item?.reviewlist[0]?.averageRating || 0}
                                    </h6>
                                  ) : null}
                                </div>
                              </div>
                              <div className="CardBottomTextBox">
                                <h3>{item?.status === 6 ? "Slot " : "Appointment "}details</h3>
                                <ul className="AppoBottomList">
                                  {item?.status === 1 ? (
                                    <>
                                      <li>
                                        <span className="RescheduledSpan">Rescheduled</span>
                                      </li>
                                      <li className="BlackList">
                                        <span className="DateSpan">{formatDate(item?.appointment_date)}</span>
                                        {/* <span className="TimeSpan">{item?.time}</span> */}
                                        {item?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{item?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(item?.time, item?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">{item?.time}</span>
                                          </>
                                        )}
                                      </li>
                                    </>
                                  ) : item?.status === 2 ? (
                                    <>
                                      <li>
                                        <span className="CanceledSpan">Canceled by doctor</span>
                                      </li>
                                      <li className="BlackList">
                                        <span className="DateSpan">{formatDate(item?.appointment_date)}</span>
                                        {/* <span className="TimeSpan">{item?.time}</span> */}
                                        {item?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{item?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(item?.time, item?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">{item?.time}</span>
                                          </>
                                        )}
                                      </li>
                                    </>
                                  ) : item?.status === 3 ? (
                                    <>
                                      <li>
                                        <span className="CanceledSpan">Doctor absent</span>
                                      </li>
                                      <li className="BlackList">
                                        <span className="DateSpan">{formatDate(item?.appointment_date)}</span>
                                        {/* <span className="TimeSpan">{item?.time}</span> */}
                                        {item?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{item?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(item?.time, item?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">{item?.time}</span>
                                          </>
                                        )}
                                      </li>
                                    </>
                                  ) : item?.status === 5 ? (
                                    <>
                                      <li className="GrayList">
                                        <span className="CompletedSpan">Appointment completed</span>
                                      </li>
                                      <li className="BlackList">
                                        <span className="DateSpan">{formatDate(item?.appointment_date)}</span>
                                        {/* <span className="TimeSpan">{item?.time}</span> */}
                                        {item?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{item?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(item?.time, item?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">{item?.time}</span>
                                          </>
                                        )}
                                      </li>
                                    </>
                                  ) : (
                                    <li className="GreenList">
                                      <span className="DateSpan">{formatDate(item?.appointment_date)}</span>
                                      {/* <span className="TimeSpan">{item?.time}</span> */}
                                      {item?.delay_id ? (
                                        <>
                                          <span>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span>
                                              <span className="prevTime">{item?.time}</span>{" "}
                                              <span className="newTime">to {showDelayedTimeFunction(item?.time, item?.delay)}</span>
                                            </span>
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <span className="TimeSpan">{item?.time}</span>
                                        </>
                                      )}
                                    </li>
                                  )}

                                  <li>
                                    <span className="UsrerName">
                                      {userData?.users?.first_name} {userData?.users?.last_name}
                                    </span>{" "}
                                    <a className="ChatLink">
                                      {item?.patient_read_count > 0 ? <span className="unReadMsgCount">{item?.patient_read_count}</span> : null}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                </div>
                {screenLoadingDoctor || screenLoading ? (
                  <div className="RightMyAppointtBox">
                    <Skeleton count={1} height={40} width={"80%"} baseColor="#cfd5f9" />
                    <br />
                    <p>
                      <Skeleton count={1} height={40} width={"70%"} baseColor="#cfd5f9" />
                    </p>
                  </div>
                ) : (
                  <>
                    {appointmentDetails ? (
                      <div className="RightMyAppointtBox">
                        <div className="RowSec">
                          <div className="HalfSec">
                            <div className="Card RightMyAppointmentCard">
                              <div className="TopCardBox">
                                <div className="ImgBox">
                                  <img
                                    src={
                                      appointmentDetails?.doctor_details?.profile_pic_url ?  appointmentDetails?.doctor_details?.profile_pic_url : DEFAULT_PROFILE_IMAGE
                                    }
                                    alt="Doctor image"
                                  />
                                </div>
                                <div className="ImgTextBox">
                                  <h4>
                                    {appointmentDetails?.doctor_details?.first_name} {appointmentDetails?.doctor_details?.last_name}
                                  </h4>
                                  <h5>{appointmentDetails?.doctor_details?.doctor_specialitie}</h5>
                                  {appointmentDetails?.reviewlist[0]?.averageRating ? (
                                    <h6>
                                      <ReactStars
                                        count={5}
                                        size={15}
                                        activeColor="#ffd700"
                                        edit={false}
                                        value={appointmentDetails?.reviewlist?.length > 0 ? appointmentDetails?.reviewlist[0]?.averageRating || 0 : 0}
                                        isHalf={true}
                                      />{" "}
                                      {appointmentDetails?.reviewlist[0]?.averageRating || 0}
                                    </h6>
                                  ) : null}
                                </div>
                              </div>
                              <div className="CardBottomTextBox">
                                <h4>Appointment date & time:</h4>

                                {appointmentDetails?.status === 1 ? (
                                  <>
                                    <ul className={`AppoBottomList ${appointmentDetails?.status === 5 ? "ComplitedAppoBottomList" : ""} `}>
                                      <li>
                                        <span className="RescheduledSpan">Rescheduled</span>
                                      </li>
                                      <li className="BlackList">
                                        <span className="DateSpan">{formatDate(appointmentDetails?.appointment_date)}</span>
                                        <span className="TimeSpan">{appointmentDetails?.time}</span>
                                      </li>
                                    </ul>
                                  </>
                                ) : appointmentDetails?.status === 2 ? (
                                  <>
                                    <ul className={`AppoBottomList ${appointmentDetails?.status === 5 ? "ComplitedAppoBottomList" : ""} `}>
                                      <li>
                                        <span className="CanceledSpan">Canceled by doctor</span>
                                      </li>
                                      <li>
                                        <span className="DateSpan">Date</span>
                                        {appointmentDetails?.appointment_date ? formatDate(appointmentDetails?.appointment_date) : ""}
                                      </li>
                                      <li>
                                        {appointmentDetails?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{appointmentDetails?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(appointmentDetails?.time, appointmentDetails?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">TIME</span>
                                            {appointmentDetails?.time}
                                          </>
                                        )}
                                      </li>
                                    </ul>
                                  </>
                                ) : appointmentDetails?.status === 3 ? (
                                  <>
                                    <ul className={`AppoBottomList ${appointmentDetails?.status === 5 ? "ComplitedAppoBottomList" : ""} `}>
                                      <li>
                                        <span className="CanceledSpan">Doctor absent</span>
                                      </li>
                                      <li>
                                        <span className="DateSpan">Date</span>
                                        {appointmentDetails?.appointment_date ? formatDate(appointmentDetails?.appointment_date) : ""}
                                      </li>
                                      <li>
                                        {appointmentDetails?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{appointmentDetails?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(appointmentDetails?.time, appointmentDetails?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">TIME</span>
                                            {appointmentDetails?.time}
                                          </>
                                        )}
                                      </li>
                                    </ul>
                                  </>
                                ) : appointmentDetails?.status === 5 ? (
                                  <>
                                    <ul className={`AppoBottomList ${appointmentDetails?.status === 5 ? "ComplitedAppoBottomList" : ""} `}>
                                      <li>
                                        <span className="DateSpan">Date</span>
                                        {appointmentDetails?.appointment_date ? formatDate(appointmentDetails?.appointment_date) : ""}
                                      </li>
                                      <li>
                                        {appointmentDetails?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{appointmentDetails?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(appointmentDetails?.time, appointmentDetails?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">TIME</span>
                                            {appointmentDetails?.time}
                                          </>
                                        )}
                                      </li>
                                      <li className="GreenList">
                                        <span className="StatusSpan">STATUS</span>
                                        Completed
                                      </li>
                                    </ul>
                                  </>
                                ) : (
                                  <>
                                    <ul
                                      className={`AppoBottomList ${appointmentDetails?.status === 5 ? "ComplitedAppoBottomList" : "UpComingAppoBottomList"} `}>
                                      <li>
                                        <span className="DateSpan">Date</span>
                                        {appointmentDetails?.appointment_date ? formatDate(appointmentDetails?.appointment_date) : ""}
                                      </li>
                                      <li>
                                        {appointmentDetails?.delay_id ? (
                                          <>
                                            <span className="TimeSpan delaySpan">Delay</span>
                                            <span className="prevTime">{appointmentDetails?.time}</span>{" "}
                                            <span className="newTime">to {showDelayedTimeFunction(appointmentDetails?.time, appointmentDetails?.delay)}</span>
                                          </>
                                        ) : (
                                          <>
                                            <span className="TimeSpan">TIME</span>
                                            {appointmentDetails?.time}
                                          </>
                                        )}
                                      </li>
                                    </ul>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="Card RightMyAppointmentCard">
                              <h3>Go to the consultation</h3>
                              <h4>Address:</h4>
                              <ul className="LeftApontlocationList">
                                <li>
                                  Cabinet
                                  <br />
                                  {appointmentDetails?.doctor_details?.cabin_address}
                                  {/* <br /> */}
                                  {/* {appointmentDetails?.doctor_details==1()=>(
                                                        <span>Ground floor<br />
                                                    )} */}
                                  {appointmentDetails?.doctor_details?.doctor_transports.map((item, index) => (
                                    <span key={index}>
                                      {item?.transport}
                                      {/* <br /> */}
                                    </span>
                                  ))}
                                  {/* <br /> */}
                                  {appointmentDetails?.doctor_details?.doctor_parkings.map((item, index) => (
                                    <span key={index}>
                                      {item?.parking}
                                      {/* <br /> */}
                                    </span>
                                  ))}
                                  {/* <br /> */}
                                  {appointmentDetails?.doctor_details?.doctor_informations.map((item, index) => (
                                    <span key={index}>
                                      {item?.information}
                                      {/* <br /> */}
                                    </span>
                                  ))}
                                  {/* {appointmentDetails?.doctor_details?.doctor_parkings?.parking}
                                                    {appointmentDetails?.doctor_details?.doctor_informations?.information} */}
                                  {/* Ground floor<br />
                                                    The Saint-Cyprien parking lot and metro <br />are a 5-minute walk away. */}
                                </li>
                              </ul>
                              {!moment(allDetails[0]?.appointment_date).isBefore(moment(), "day") ? (
                                <ul className="actionsButton">
                                  <li className="cancelLink" onClick={() => setShowCancelAppointmnet(true)}>
                                    Cancel Appointment
                                  </li>
                                  <li className="rescheduleLink" onClick={() => setReschedulePopupShow(true)}>
                                    Reschedule Appointment
                                  </li>
                                </ul>
                              ) : null}
                            </div>
                          </div>
                          <div className="HalfSec">
                            <div className="Card RightMyAppointmentCard">
                              <h3>Patient</h3>
                              <h4>Patient name:</h4>
                              <div className="PatientNameBox">
                                {appointmentDetails?.patient_details.map((item, index) => (
                                  <span key={index}>
                                    {item?.first_name} {item?.last_name}
                                    <br />
                                  </span>
                                ))}
                              </div>
                              <button className="ShareBtn" onClick={() => setSharePopupShow(true)}>
                                Share with someone
                              </button>
                            </div>
                            <div className="Card RightMyAppointmentCard2">
                              <button className="AddNoteBtn" onClick={toggleModal2}>
                                <img src={AddIcon} alt="Doctor image" /> Add a note
                              </button>
                            </div>
                            <div className="Card RightMyAppointmentCard2">
                              <button className="RelatedBtn">
                                <img src={RelatedDocumentIcon} alt="Doctor image" /> Access related document
                              </button>
                            </div>
                            <div className="Card RightMyAppointmentCard2">
                              <button
                                className={`WriteReviewBtn ${appointmentDetails?.status !== 5 ? "WriteReviewDisabledBtn" : ""}`}
                                disabled={appointmentDetails?.status !== 5 ? true : false}
                                onClick={() => setShowModal1(true)}>
                                <img src={WriteReviewDisabledIcon} alt="Doctor image" /> Write a review
                                {appointmentDetails?.reviewlist?.length > 0 ? <span>You had 1 review</span> : null}
                              </button>
                            </div>
                          </div>
                        </div>
                        {showModal1 && (
                          <div className="modal WriteReviewModal" onClick={toggleModal1}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                              <button
                                className="CloseButton"
                                onClick={() => {
                                  setShowModal1(false);
                                  setWriteReviewObj({star: 0, review: ""});
                                }}></button>
                              <h3>Review & Rating</h3>
                              <div className="ReviewImg">
                                <img
                                  src={appointmentDetails?.doctor_details?.profile_pic_url ?  appointmentDetails?.doctor_details?.profile_pic_url : DEFAULT_PROFILE_IMAGE}
                                  alt="Doctor image"
                                />
                              </div>
                              <div className="BottmContent">
                                <h4>
                                  Dr {appointmentDetails?.doctor_details?.first_name} {appointmentDetails?.doctor_details?.last_name}
                                </h4>
                                <h5>{appointmentDetails?.doctor_details?.temp_speciality}</h5>
                                {/* <p>Rating the care provided on June 17, 2024</p> */}
                                <ul className="RatingList">
                                  <li>
                                    {/* <img src={RatingImg} alt="Doctor image" /> */}
                                    <ReactStars
                                      count={5}
                                      onChange={value => setWriteReviewObj(prev => ({...prev, star: value}))}
                                      size={50}
                                      activeColor="#ffd700"
                                      edit={appointmentDetails?.reviewlist?.length > 0 ? false : true}
                                      value={appointmentDetails?.reviewlist?.length > 0 ? appointmentDetails?.reviewlist[0]?.rating || 0 : writeReviewObj?.star}
                                      isHalf={true}
                                    />
                                  </li>
                                </ul>
                                <ul className="FormList">
                                  <li>
                                    <label>Additional comments</label>
                                  </li>
                                  <li>
                                    <textarea
                                      cols={3}
                                      rows={4}
                                      placeholder="Type here..."
                                      className="FormTextarea"
                                      value={
                                        appointmentDetails?.reviewlist?.length > 0 ? appointmentDetails?.reviewlist[0]?.comment || "" : writeReviewObj?.review
                                      }
                                      disabled={appointmentDetails?.reviewlist?.length > 0 ? true : false}
                                      onChange={e => setWriteReviewObj(prev => ({...prev, review: e.target.value}))}></textarea>
                                  </li>
                                </ul>
                              </div>
                              {appointmentDetails?.reviewlist?.length === 0 ? (
                                <ul className="ButtonList">
                                  <li>
                                    <button
                                      className="CancelBtn"
                                      onClick={() => {
                                        setShowModal1(false);
                                        setWriteReviewObj({star: 0, review: ""});
                                      }}>
                                      Not Now
                                    </button>
                                  </li>
                                  <li>
                                    <button className="ModalCloseBtn" onClick={() => handleSubmitReview()} disabled={modalBtnDis}>
                                      {modalBtnDis ? "Please wait..." : "Submit"}
                                    </button>
                                  </li>
                                </ul>
                              ) : null}
                            </div>
                          </div>
                        )}
                        <div className="Card PatientsChatCard">
                          <button
                            className={`PatientsChatButton ${isActive ? "active" : "inactive"}`}
                            onClick={() => {
                              toggleVisibility();
                              readAppointmentMessage();
                            }}>
                            <span className="PatientImgBox">
                              <img src={userData.users?.profile_pic_url ?  userData.users?.profile_pic_url : DEFAULT_PROFILE_IMAGE} alt="Doctor image" />
                            </span>
                            <div className="PatientImgTextBox">
                              <div className="LeftImgTextBox">
                                <h4>
                                  {userData.users.first_name} {userData.users.last_name}
                                </h4>
                                <h5>{userData.users.cell_phone}</h5>
                              </div>
                              <span className="ChatLink">
                                <img src={ChatImg} alt="Doctor image" />
                                {appointmentDetails?.patient_read_count > 0 ? (
                                  <span className="unReadMsgCount">{appointmentDetails?.patient_read_count}</span>
                                ) : null}
                              </span>
                            </div>
                          </button>
                          {isVisible && (
                            <div className="modalChatBox">
                              <div className="topChatBox">
                                <button
                                  className="hamburger_menu"
                                  onClick={() => {
                                    toggleVisibility();
                                    readAppointmentMessage();
                                  }}>
                                  <X size={24} />
                                </button>
                                <div className="BottomChatBox">
                                  <ul className="ChatList" ref={chatListRef}>
                                    {messageList?.length > 0 ? (
                                      messageList?.map((item, index) => (
                                        <li key={index} className={item?.from_id === userData?.users?.id ? "UserList" : ""}>
                                          <div className="ChatInfoTop">
                                            <div className="ChatUserInfo">
                                              {/* <h4>
                                            {item?.from_id !== userData?.users?.id
                                              ? appointmentDetails?.doctor_details?.first_name + " " + appointmentDetails?.doctor_details?.last_name
                                                : "From Patient"}
                                              :
                                            </h4> */}
                                              <h4 className={`${item?.types === "refer" ? "referTo" : ""}`}>
                                                {item?.from_id !== userData?.users?.id ? (
                                                  <>
                                                    {appointmentDetails?.doctor_details?.first_name} {appointmentDetails?.doctor_details?.last_name}{" "}
                                                    {item?.from_type === "Doctor" && item?.to_type === "Doctor"
                                                      ? `${item?.types === "refer" ? <>refer to Dr. {item?.refer_name}</> : <>to Dr. {item?.to}</>} `
                                                      : item?.from_type === "Doctor" && item?.types === "refer"
                                                      ? `refer to Dr. ${item?.refer_name}`
                                                      : ""}
                                                  </>
                                                ) : (
                                                  // `From Patient (${item?.from_type === "Patient" ? item?.from : ""})`
                                                  `You`
                                                )}
                                              </h4>
                                              <h5>{chatMessgaeDateFormat(item?.date)}</h5>
                                              {/* <h5>Today at 17:30</h5> */}
                                            </div>
                                          </div>
                                          {item?.message && item?.types !== "refer" ? (
                                            <div className={`DoctorChatContent ${item?.from_id !== userData?.users?.id ? "" : "DoctorChatContent2"}`}>
                                              {item?.message}
                                            </div>
                                          ) : null}

                                          {item?.file_name && item?.files ? (
                                            <div
                                              className={`DoctorChatContent ${item?.from_id !== userData?.users?.id ? "" : "DoctorChatContent2"} fileSection`}>
                                              {" "}
                                              {getFileExtension(item.file_name) === "pdf" ? (
                                                item?.from_id === userData?.users?.id ? (
                                                  <img src={whitePdfIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                                ) : (
                                                  <img src={blackPdfIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                                )
                                              ) : getFileExtension(item.file_name) === "docx" ? (
                                                item?.from_id === userData?.users?.id ? (
                                                  <img src={whiteDocxIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                                ) : (
                                                  <img src={blackDocxIcon} className="downloadIcon normalIcon" alt="downloadIcon" />
                                                )
                                              ) : item?.from_id === userData?.users?.id ? (
                                                <img src={whiteImageIcon} className="downloadIcon normalIcon" alt="whiteImageIcon" />
                                              ) : (
                                                <img src={blackImageIcon} className="downloadIcon normalIcon" alt="whiteImageIcon" />
                                              )}
                                              {item?.file_name}{" "}
                                              {item?.from_id === userData?.users?.id ? (
                                                <img
                                                  src={whiteDownloadIcon}
                                                  className="downloadIcon"
                                                  alt="downloadIcon"
                                                  onClick={() => handleDownload( item?.files, item?.file_name)}
                                                />
                                              ) : (
                                                <img
                                                  src={downloadIcon}
                                                  className="downloadIcon"
                                                  alt="downloadIcon"
                                                  onClick={() => handleDownload( item?.files, item?.file_name)}
                                                />
                                              )}
                                            </div>
                                          ) : null}
                                        </li>
                                      ))
                                    ) : (
                                      <li className="EmptyChatSection">
                                        <div className="DoctorChatContent">Conversation is empty.</div>
                                      </li>
                                    )}
                                    {/* <li>
                                  <div className="ChatInfoTop">
                                    <div className="ChatUserImg">
                                      <img src={ChatUserImg1} alt="Doctor image" />
                                    </div>
                                    <div className="ChatUserInfo">
                                      <h4>Kestrel Tabrizi</h4>
                                      <h5>Today at 17:40</h5>
                                    </div>
                                  </div>
                                  <div className="DoctorChatContent">
                                    Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?
                                    <br />
                                    <br />
                                    Let's conversation together to betterment your issues!
                                  </div>
                                </li> */}
                                  </ul>
                                  <div className="BottomChatTextBox">
                                    <textarea
                                      className="FormTextarea"
                                      placeholder="Write a message here..."
                                      value={messageText}
                                      onChange={e => setMessageText(e.target.value)}></textarea>
                                    {/* {messageSenderObj ? (
                                  <div className="showSenderSection">
                                    <span>
                                      To {messageSenderObj?.type === "to-doctor" ? "doctor" : messageSenderObj?.type === "to-patient" ? "patient" : ""}:{" "}
                                      <span className="nameSection">
                                        {messageSenderObj?.selectedItem?.first_name} {messageSenderObj?.selectedItem?.last_name}
                                      </span>
                                      <span>
                                        {" "}
                                        <img src={CrossIcon} className="CrossIcon" onClick={() => setMessageSenderObj(null)} />
                                      </span>
                                    </span>
                                  </div>
                                ) : null} */}

                                    <a className="ChatAttachIcon">
                                      {!messageFile ? (
                                        <>
                                          <img src={ChatAttachIcon} alt="Doctor image" onClick={() => chatFileRef?.current?.click()} />
                                          <input
                                            type="file"
                                            accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            hidden
                                            ref={chatFileRef}
                                            onChange={e => handleChatFileChange(e)}
                                          />
                                        </>
                                      ) : (
                                        <div className="selectedFileSection">
                                          <span>{messageFile?.name}</span>
                                          <span>
                                            <img src={CrossIcon} className="CrossIcon" onClick={() => setMessageFile(null)} />
                                          </span>
                                        </div>
                                      )}
                                    </a>
                                    <button className="ChatButton" disabled={messageSending} onClick={() => handleSendMesssage()}></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {notesList?.length > 0 ? (
                          <div className="Card NoteBox">
                            <h3>Note</h3>
                            {notesList?.map((item, index) => (
                              <p className="DisabledPara" key={index}>
                                {item?.notes}
                              </p>
                            ))}
                            <ul className="NoteBtnList" style={{display: "none"}}>
                              <li>
                                <button className="EditBtn">Edit Note</button>
                              </li>
                              <li>
                                <button className="DeleteBtn">Delete Note</button>
                              </li>
                            </ul>
                          </div>
                        ) : null}
                      </div>
                    ) : !screenLoadingDoctor && !screenLoading ? (
                      <div className="RightMyAppointtBox RightMyAppointtBoxBlank">
                        <img src={NoAppointmentCalendarIcon} alt="" />
                        <h4>No appointments</h4>
                        <p>Find a practitioner and make an appointment online at any time.</p>
                        <div></div>
                        <button className="AppointmentBtn" onClick={() => navigate("/")}>
                          Make an appointment
                        </button>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
              {showModal2 && (
                <div className="modal AddNoteModal" onClick={toggleModal2}>
                  <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <button className="CloseButton" onClick={toggleModal2}></button>
                    <h3>Add Note</h3>
                    <div className="BottmContent">
                      <ul className="FormList">
                        <li>
                          <textarea placeholder="Type here..." className="FormTextarea" value={noteText} onChange={e => setNoteText(e.target.value)}></textarea>
                        </li>
                      </ul>
                    </div>
                    <ul className="ButtonList">
                      <li>
                        <button
                          className="CancelBtn"
                          onClick={() => {
                            setShowModal2(false);
                            setNoteText(null);
                          }}>
                          Canel note
                        </button>
                      </li>
                      <li>
                        <button className="ModalCloseBtn" onClick={() => addPatientNote()} disabled={noteBtnDis}>
                          {noteBtnDis ? "Please wait.." : "Submit"}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {sharePopupShow && (
                <div className="modal AddNoteModal" onClick={() => setSharePopupShow(false)}>
                  <div className="modal-content shareModal" onClick={e => e.stopPropagation()}>
                    <button className="CloseButton" onClick={() => setSharePopupShow(false)}></button>
                    <h3>Share doctor profile</h3>
                    <div className="BottmContent">
                      <div className="ShareButtonCont">
                        <div className="ShareButton">
                          <FacebookShareButton
                            url={window.location.protocol + window.location.host + "/search/doctor-details/" + appointmentDetails?.doctor_details?.slug}>
                            <FacebookIcon size={40} round={true} />
                          </FacebookShareButton>
                        </div>
                        <div className="ShareButton">
                          <WhatsappShareButton
                            url={window.location.protocol + window.location.host + "/search/doctor-details/" + appointmentDetails?.doctor_details?.slug}>
                            <WhatsappIcon size={40} round={true} />
                          </WhatsappShareButton>
                        </div>
                        <div className="ShareButton">
                          <TwitterShareButton
                            url={window.location.protocol + window.location.host + "/search/doctor-details/" + appointmentDetails?.doctor_details?.slug}>
                            <TwitterIcon size={40} round={true} />
                          </TwitterShareButton>
                        </div>
                        <div className="ShareButton">
                          <LinkedinShareButton
                            url={window.location.protocol + window.location.host + "/search/doctor-details/" + appointmentDetails?.doctor_details?.slug}>
                            <LinkedinIcon size={40} round={true} />
                          </LinkedinShareButton>
                        </div>
                        <div className="ShareButton">
                          <TelegramShareButton
                            url={window.location.protocol + window.location.host + "/search/doctor-details/" + appointmentDetails?.doctor_details?.slug}>
                            <TelegramIcon size={40} round={true} />
                          </TelegramShareButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* {activeTab === 'upcoming' && (
                    <div id="upcoming" className="TabContentBlock">
                        <div className="MyAppointmentBox">
                            <div className="LeftMyAppointtBox">
                                <ul className="AppointmentList">
                                    <li className="UpcomingList">
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Debrorah Dang</h4>
                                                    <h5>Dentist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li className="GreenList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg2} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Francine Gerard</h4>
                                                    <h5>Physiotherapist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="RescheduledSpan">Rescheduled</span></li>
                                                    <li className="BlackList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="BlackList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg3} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr John Doe</h4>
                                                    <h5>Physiotherapist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Canceled by doctor</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="PatientFault">
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg4} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Parlo Mascuta</h4>
                                                    <h5>Gastroenterologist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Patient not attended</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg4} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Parlo Mascuta</h4>
                                                    <h5>Gastroenterologist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Doctor absent</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox">
                                                    <img src={DoctorImg6} alt="Doctor image" />
                                                    <div className="VideoIconBox"><img src={VideoIcon} alt="Doctor image" /></div>  
                                                </div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Jean Philippe MENAT</h4>
                                                    <h5>Dietitian/Nutritionist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li className="GrayList"><span className="CompletedSpan">Appointment completed</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="RightMyAppointtBox">
                                <div className="RowSec">
                                    <div className="HalfSec">
                                        <div className="Card RightMyAppointmentCard">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr. Deborah Dang</h4>
                                                    <h5>Dentist</h5>
                                                    <h6><img src={StarIcon2} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h4>Appointment date & time:</h4>
                                                <ul className="AppoBottomList UpComingAppoBottomList">
                                                    <li>
                                                        <span className="DateSpan">Date</span>
                                                        June 17, 2024
                                                    </li>
                                                    <li>
                                                        <span className="TimeSpan">TIME</span>
                                                        20:30
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="Card RightMyAppointmentCard">
                                            <h3>Go to the consultation</h3>
                                            <h4>Address:</h4>
                                            <ul className="LeftApontlocationList">
                                                <li>Cabinet Les Arcades<br />
                                                    93-95 Allees Charles de fitte<br />
                                                    31300 toulose<br />
                                                    <span>Ground floor<br />
                                                    The Saint-Cyprien parking lot and metro <br />are a 5-minute walk away.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="HalfSec">
                                        <div className="Card RightMyAppointmentCard">
                                            <h3>Patient</h3>
                                            <h4>Patient name:</h4>
                                            <div className="PatientNameBox">Kestrel Tabrizi</div>
                                            <button className="ShareBtn">Share with someone</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="AddNoteBtn" onClick={toggleModal22}><img src={AddIcon} alt="Doctor image" /> Add a note</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="RelatedBtn"><img src={RelatedDocumentIcon} alt="Doctor image" /> Access related document</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="WriteReviewBtn WriteReviewDisabledBtn"><img src={WriteReviewDisabledIcon} alt="Doctor image" /> Write a review</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="Card PatientsChatCard">
                                    <button className={`PatientsChatButton ${isActive2 ? 'active' : 'inactive'}`} onClick={toggleVisibility2}>
                                        <span className="PatientImgBox"><img src={DoctorImg3} alt="Doctor image" /></span>
                                        <div className="PatientImgTextBox">
                                            <div className="LeftImgTextBox">
                                                <h4>Kestrel Tabrizi</h4>
                                                <h5>(415) 851-8951</h5>
                                            </div>
                                            <span className="ChatLink"><img src={ChatImg} alt="Doctor image" /></span>
                                        </div>
                                    </button>
                                    {isVisible2 && (
                                        <div className="BottomChatBox">
                                            <ul className="ChatList">
                                                <li>
                                                    <div className="ChatInfoTop">
                                                        <div className="ChatUserImg"><img src={ChatUserImg1} alt="Doctor image" /></div>
                                                        <div className="ChatUserInfo">
                                                            <h4>Kestrel Tabrizi</h4>
                                                            <h5>Today at 17:40</h5>
                                                        </div>
                                                    </div>
                                                    <div className="DoctorChatContent">
                                                    Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?<br /><br />
                                                    Let's conversation together to betterment your issues!
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="ChatInfoTop">
                                                        <div className="ChatUserImg"><img src={ChatUserImg1} alt="Doctor image" /></div>
                                                        <div className="ChatUserInfo">
                                                            <h4>Kestrel Tabrizi</h4>
                                                            <h5>Today at 17:40</h5>
                                                        </div>
                                                    </div>
                                                    <div className="DoctorChatContent DoctorChatContent2">
                                                    Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?<br /><br />
                                                    Let's conversation together to betterment your issues!
                                                    </div>
                                                </li>
                                            </ul>
                                            <div className="BottomChatTextBox">
                                                <textarea className="FormTextarea" placeholder="Write a message here..."></textarea>
                                                <a className="ChatAttachIcon"><img src={ChatAttachIcon} alt="Doctor image" /></a>
                                                <button className="ChatButton"></button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="Card NoteBox">
                                    <h3>Note</h3>
                                    <p className="DisabledPara">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
                                    <ul className="NoteBtnList" style={{display: "none"}}>
                                        <li><button className="EditBtn">Edit Note</button></li>
                                        <li><button className="DeleteBtn">Delete Note</button></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {showModal22 && (
                            <div className="modal AddNoteModal" onClick={toggleModal22}>
                                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                    <button className="CloseButton" onClick={toggleModal22}></button>
                                    <h3>Add Note</h3>
                                    <div className="BottmContent">
                                        <ul className="FormList">
                                            <li><textarea placeholder="Type here..." className="FormTextarea"></textarea></li>
                                        </ul>
                                    </div>
                                    <ul className="ButtonList">
                                        <li><button className="CancelBtn" onClick={toggleModal22}>Canel note</button></li>
                                        <li><button className="ModalCloseBtn" onClick={toggleModal22}>Submit</button></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {activeTab === 'past' && (
                    <div id="past" className="TabContentBlock">
                        <div className="MyAppointmentBox">
                            <div className="LeftMyAppointtBox">
                                <ul className="AppointmentList">
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Debrorah Dang</h4>
                                                    <h5>Dentist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li className="GreenList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg2} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Francine Gerard</h4>
                                                    <h5>Physiotherapist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="RescheduledSpan">Rescheduled</span></li>
                                                    <li className="BlackList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="BlackList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg3} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr John Doe</h4>
                                                    <h5>Physiotherapist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Canceled by doctor</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="PatientFault">
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg4} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Parlo Mascuta</h4>
                                                    <h5>Gastroenterologist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Patient not attended</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox"><img src={DoctorImg5} alt="Doctor image" /></div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Imran Ahmed</h4>
                                                    <h5>Gastroenterologist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li><span className="CanceledSpan">Doctor absent</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="Selected">
                                        <div className="Card">
                                            <div className="TopCardBox">
                                                <div className="ImgBox">
                                                    <img src={DoctorImg6} alt="Doctor image" />
                                                    <div className="VideoIconBox"><img src={VideoIcon} alt="Doctor image" /></div>  
                                                </div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr Jean Philippe MENAT</h4>
                                                    <h5>Dietitian/Nutritionist</h5>
                                                    <h6><img src={StarIcon} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h3>Appointment details</h3>
                                                <ul className="AppoBottomList">
                                                    <li className="GrayList"><span className="CompletedSpan">Appointment completed</span></li>
                                                    <li className="GrayList"><span className="DateSpan">June 17, 2024</span> <span className="TimeSpan">20:30</span></li>
                                                    <li className="GrayList"><span className="UsrerName">Kestrel Tabrizi</span> <a className="ChatLink"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="RightMyAppointtBox">
                                <div className="RowSec">
                                    <div className="HalfSec">
                                        <div className="Card RightMyAppointmentCard">
                                            <div className="TopCardBox">
                                                <div className="ImgBox">
                                                    <img src={DoctorImg6} alt="Doctor image" />
                                                    <div className="VideoIconBox"><img src={VideoIcon} alt="Doctor image" /></div>  
                                                </div>
                                                <div className="ImgTextBox">
                                                    <h4>Dr. Jean Philippe MENAT</h4>
                                                    <h5>Dietitian/Nutritionist</h5>
                                                    <h6><img src={StarIcon2} alt="Doctor image" /> 4.5</h6>
                                                </div>
                                            </div>
                                            <div className="CardBottomTextBox">
                                                <h4>Appointment date & time:</h4>
                                                <ul className="AppoBottomList ComplitedAppoBottomList">
                                                <li>
                                                    <span className="DateSpan">Date</span>
                                                    June 17, 2024
                                                </li>
                                                <li className="OrangeList">
                                                    <span className="TimeSpan">TIME</span>
                                                    22:30
                                                </li>
                                                <li className="GreenList">
                                                    <span className="StatusSpan">STATUS</span>
                                                    Completed
                                                </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="Card RightMyAppointmentCard">
                                            <h3>Go to the consultation</h3>
                                            <h4>Address:</h4>
                                            <ul className="LeftApontlocationList">
                                                <li>Cabinet Les Arcades<br />
                                                    93-95 Allees Charles de fitte<br />
                                                    31300 toulose<br />
                                                    <span>Ground floor<br />
                                                    The Saint-Cyprien parking lot and metro <br />are a 5-minute walk away.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="HalfSec">
                                        <div className="Card RightMyAppointmentCard">
                                            <h3>Patient</h3>
                                            <h4>Patient name:</h4>
                                            <div className="PatientNameBox">Kestrel Tabrizi</div>
                                            <button className="ShareBtn">Share with someone</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="AddNoteBtn" onClick={toggleModal23}><img src={AddIcon} alt="Doctor image" /> Add a note</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="RelatedBtn"><img src={RelatedDocumentIcon} alt="Doctor image" /> Access related document</button>
                                        </div>
                                        <div className="Card RightMyAppointmentCard2">
                                            <button className="WriteReviewBtn" onClick={toggleModal1}><img src={WriteReviewDisabledIcon} alt="Doctor image" /> Write a review</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="Card PatientsChatCard">
                                    <button className={`PatientsChatButton ${isActive ? 'active' : 'inactive'}`} onClick={toggleVisibility}>
                                        <span className="PatientImgBox"><img src={DoctorImg3} alt="Doctor image" /></span>
                                        <div className="PatientImgTextBox">
                                            <div className="LeftImgTextBox">
                                                <h4>Kestrel Tabrizi</h4>
                                                <h5>(415) 851-8951</h5>
                                            </div>
                                            <span className="ChatLink"><img src={ChatImg} alt="Doctor image" /></span>
                                        </div>
                                    </button>
                                    {isVisible && (
                                        <div className="BottomChatBox">
                                            <ul className="ChatList">
                                                <li>
                                                    <div className="ChatInfoTop">
                                                        <div className="ChatUserImg"><img src={ChatUserImg1} alt="Doctor image" /></div>
                                                        <div className="ChatUserInfo">
                                                            <h4>Kestrel Tabrizi</h4>
                                                            <h5>Today at 17:40</h5>
                                                        </div>
                                                    </div>
                                                    <div className="DoctorChatContent">
                                                    Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?<br /><br />
                                                    Let's conversation together to betterment your issues!
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="ChatInfoTop">
                                                        <div className="ChatUserImg"><img src={ChatUserImg1} alt="Doctor image" /></div>
                                                        <div className="ChatUserInfo">
                                                            <h4>Kestrel Tabrizi</h4>
                                                            <h5>Today at 17:40</h5>
                                                        </div>
                                                    </div>
                                                    <div className="DoctorChatContent DoctorChatContent2">
                                                    Hi, I understand you're having some issues with your ankle. Can you tell me a little bit about what's going on?<br /><br />
                                                    Let's conversation together to betterment your issues!
                                                    </div>
                                                </li>
                                            </ul>
                                            <div className="BottomChatTextBox">
                                                <textarea className="FormTextarea" placeholder="Write a message here..."></textarea>
                                                <a className="ChatAttachIcon"><img src={ChatAttachIcon} alt="Doctor image" /></a>
                                                <button className="ChatButton"></button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="Card NoteBox">
                                    <h3>Note</h3>
                                    <p className="DisabledPara">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
                                    <ul className="NoteBtnList" style={{display: "none"}}>
                                        <li><button className="EditBtn">Edit Note</button></li>
                                        <li><button className="DeleteBtn">Delete Note</button></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {showModal1 && (
                            <div className="modal WriteReviewModal" onClick={toggleModal1}>
                                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                    <button className="CloseButton" onClick={toggleModal1}></button>
                                    <h3>Review & Rating</h3>
                                    <div className="ReviewImg">
                                        <img src={ReviewImg} alt="Doctor image" />
                                    </div>
                                    <div className="BottmContent">
                                        <h4>Dr Francine Gerard</h4>
                                        <h5>Gastroenterologist</h5>
                                        <p>Rating the care provided on  June 17, 2024</p>
                                        <ul className="RatingList">
                                            <li><img src={RatingImg} alt="Doctor image" /></li>
                                        </ul>
                                        <ul className="FormList">
                                            <li><label>Additional comments</label></li>
                                            <li><textarea cols={3} rows={4} placeholder="Type here..." className="FormTextarea"></textarea></li>
                                        </ul>
                                    </div>
                                    <ul className="ButtonList">
                                        <li><button className="CancelBtn" onClick={toggleModal1}>Not Now</button></li>
                                        <li><button className="ModalCloseBtn" onClick={toggleModal1}>Submit</button></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                        {showModal23 && (
                            <div className="modal AddNoteModal" onClick={toggleModal23}>
                                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                    <button className="CloseButton" onClick={toggleModal23}></button>
                                    <h3>Add Note</h3>
                                    <div className="BottmContent">
                                        <ul className="FormList">
                                            <li><textarea placeholder="Type here..." className="FormTextarea"></textarea></li>
                                        </ul>
                                    </div>
                                    <ul className="ButtonList">
                                        <li><button className="CancelBtn" onClick={toggleModal23}>Canel note</button></li>
                                        <li><button className="ModalCloseBtn" onClick={toggleModal23}>Submit</button></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                )} */}
          </div>
        </div>
      </div>
      {reschedulePopupShow && (
        <div className="popup holidayPopup ReschedulePopup">
          <div className="popup-content">
            <button onClick={() => setReschedulePopupShow(false)} className="cancelBtn">
              <img src={cancelIcon} alt="cancelIcon" />
            </button>
            <div className="popupInner">
              <div className="calendar-section">
                <h3>Reschedule</h3>
                <h5>Make date specific changes</h5>
                <div className="calenderContent">
                  <div className="overlayBtn"></div>
                  <Calendar
                    onChange={handleDateClick}
                    value={calendarValue}
                    tileClassName={tileClassName}
                    onActiveStartDateChange={handleActiveStartDateChange}
                    minDate={new Date()}
                  />
                </div>
              </div>
              <div className="selected-dates">
                <div className="TopHead">
                  <h3>
                    {format(calendarValue, "EEEE")} <span>{format(calendarValue, "MMMM d, yyyy")}</span>
                  </h3>
                  <p>Available Time Slot</p>
                </div>
                {skelLoading ? (
                  <div className="SkelWrapper">
                    <Skeleton count={2} height={20} width={"80%"} baseColor="#cfd5f9" />
                  </div>
                ) : (
                  <ul>
                    {availDates?.length > 0 && !moment(calendarValue).isSameOrAfter(futureDate) ? (
                      availDates?.map((item, index) => {
                        const currentTime = moment().add(1, "hour");
                        const isToday = moment(calendarValue).isSame(currentTime, "day");
                        return (
                          // <li key={index} className={selectedTime === item ? "active" : ""} onClick={() => setSelectedTime(item)}>
                          item?.has_interval === 1 ? (
                            isToday ? (
                              moment(item?.start_time, "HH:mm").isSameOrAfter(currentTime) ? (
                                <li
                                  key={index}
                                  className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                  onClick={() => handleSelectTime(item)}>
                                  <span>
                                    {item?.start_time} to {item?.end_time}
                                  </span>
                                </li>
                              ) : null
                            ) : (
                              <li
                                key={index}
                                className={selectedTime === item?.start_time + "-" + item?.end_time ? "active" : ""}
                                onClick={() => handleSelectTime(item)}>
                                <span>
                                  {item?.start_time} to {item?.end_time}
                                </span>
                              </li>
                            )
                          ) : (
                            generateTimeSlots(item?.start_time, item?.end_time, item?.intervals, item?.time_slot_type).map((timeItem, timeIndex) => {
                              if (isToday) {
                                if (moment(timeItem, "HH:mm").isSameOrAfter(currentTime)) {
                                  return (
                                    <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""} onClick={() => handleSelectTime(timeItem)}>
                                      <span>{timeItem}</span>
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              } else {
                                return (
                                  <li key={timeIndex} className={selectedTime === timeItem ? "active" : ""} onClick={() => handleSelectTime(timeItem)}>
                                    <span>{timeItem}</span>
                                  </li>
                                );
                              }
                            })
                          )
                        );
                      })
                    ) : (
                      <p>No times available for this day.</p>
                    )}
                  </ul>
                )}
                <div className="BottomSecion">
                  <label>What is reason of appointment reschedule?</label>
                  <div className="CustomSelect">
                    <select value={rescheduleReason} onChange={e => setRescheduleReason(e.target.value)}>
                      <option selected hidden value={null}>
                        Select reason here
                      </option>
                      {rescheduleReasonList?.map((item, index) => (
                        <option key={index} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button className="saveBtn2" onClick={() => handleReschedule()} disabled={modalBtnDis}>
                  {modalBtnDis ? "Please wait..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showCancelAppointmnet && (
        <div className="modal CancelAppointmnetModal" onClick={toggleCancelAppointmnet}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <button className="CloseButton" onClick={toggleCancelAppointmnet}></button>
              <h3>Cancel appointment</h3>
              <p>Are you sure you want to cancel this appointment?</p>
            </div>
            <div className="modal-body">
              <ul className="AddIndicatorList">
                <li>
                  <label>What is reason of appointment cancellation?</label>
                  <div className="CustomSelect">
                    <select value={cancelReason} onChange={e => setCancelReason(e.target.value)}>
                      <option selected hidden>
                        Select reason here
                      </option>
                      {cancelReasonList?.map((item, index) => (
                        <option key={index} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </li>
              </ul>
            </div>
            <ul className="ButtonList">
              <li>
                <button className="ModalCloseBtn" disabled={modalBtnDis} onClick={() => handleCancelAppointment()}>
                  {modalBtnDis ? "Please wait..." : "Yes Cancel Appointment"}
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAppointment;
